import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Cabecera from "../../components/Layout/CabeceraHomePublica";
import PreguntasVehiculos from "../../components/PreguntasVehiculos";
import { contenidosFetch } from "../../redux/actions/aContenidos";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { Container, Col, Row, Button, } from "reactstrap";
import { Link } from "react-router-dom";
import SliderVideos from "../../components/Slider/SliderVideos";
class ContainerProductosMenu extends Component {

  onClickCotizar = () => {
    //event.preventDefault();

    let ObtenerSeccion2 = this.props.datosContenido.contenidos.paginas.filter((objeto) =>
      parseInt(objeto.seccion) === 2
    )
    let path = ObtenerSeccion2[0] ? ObtenerSeccion2[0].contenido.url_redireccion : "";
    let search = ObtenerSeccion2[0] ? ObtenerSeccion2[0].contenido.url_icono_img : "";
    this.props.history.replace({
      pathname: path,
      search: search
    });
  };
 
    componentDidMount() {
      const queryParams = new URLSearchParams(this.props.location.search);
      const codigo=queryParams.get('codigo');
      const id=queryParams.get('id');
      this.props.obtenerContenido(codigo,id);      
    }
    
    componentDidUpdate(prevProps, prevState) {
      
    //debugger
      if(prevProps.location !== this.props.location)
      {
         const queryParams = new URLSearchParams(this.props.location.search);
         const codigo=queryParams.get('codigo');
         const id=queryParams.get('id');
         if(codigo && codigo !== null && codigo !== undefined)
         {
          this.props.obtenerContenido(codigo,id);   
         }

      }
    }

    render() {
      const { carritoVisible } = this.props;
      /*Obtener Seccion 0 Banner */
      let banner="";
      let imgvehiculo="";
      let ObtenerSeccion1="";
      let ObtenerBanner="";
      let ObtenerTituloAcordeon="";
      let tituloAcordeon=""
      let ObtenerSeccion2BotonCotizar="";
      let mostrarBotonCotizar=true;

      if(this.props.datosContenido.contenidos && this.props.datosContenido.contenidos.paginas !== undefined && this.props.datosContenido.contenidos.paginas !== "")
      {
        ObtenerBanner=this.props.datosContenido.contenidos.paginas.filter((objeto) =>
        parseInt(objeto.seccion) === 0
        )
        ObtenerSeccion1=this.props.datosContenido.contenidos.paginas.filter((objeto) =>
        parseInt(objeto.seccion) === 1
        )
        ObtenerSeccion2BotonCotizar=this.props.datosContenido.contenidos.paginas.filter((objeto) =>
        parseInt(objeto.seccion) === 2
        )
        ObtenerTituloAcordeon=this.props.datosContenido.contenidos.paginas.filter((objeto) =>
        objeto.seccion === "tituloAcordeon"
        )

        mostrarBotonCotizar=(ObtenerSeccion2BotonCotizar[0] === undefined || ObtenerSeccion2BotonCotizar[0] === null )? false : true;
        tituloAcordeon=ObtenerTituloAcordeon[0] ? ObtenerTituloAcordeon[0].contenido.titulo : "";
        imgvehiculo = ObtenerSeccion1[0] ? ObtenerSeccion1[0].contenido.url_icono_img : "";
        banner= ObtenerBanner[0] ? ObtenerBanner[0].contenido.url_icono_img : "";
      }
        return (
          <LoadingScreen
        loading={this.props.datosContenido.contenidosIsLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Cargando..."
      >
        <main className="cr-app-home main-bordes">
            <div className="cr-content-home">
                <div>
                <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <Cabecera carritoVisible={carritoVisible}/>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    {this.props.datosContenido && this.props.datosContenido.contenidos && this.props.datosContenido.contenidos.hermanos && 

                      <div className="div-darra-fondo-submenu">
                            <ul className="centrar-submenu">
                                {this.props.datosContenido.contenidos.hermanos.map(({ nombre, urlDetalle, id, preSobre, marcaSeleccionado}) =>                                                                        
                                      <li className="estilo-li">                                      
                                          <Link 
                                            // className="a-submenu a-submenu-active" 
                                            className={marcaSeleccionado?"a-submenu a-submenu-active":"a-submenu"}
                                            to={`${urlDetalle}?id=${id}&codigo=${preSobre}`}>
                                              {nombre}
                                          </Link>
                                      </li>                                    
                                  )}
                            </ul>                                                    
                      </div>              
                    }                    
                    <img src={banner} alt={''} className={"slide-principal-front"} />
                  </Col>
                </Row>
                </div>
                <Container>
                    <Row>
                      <Col lg={9} md={12} sm={12} xs={12}>
                        <br></br>
                        <div className={"titulos-texto-productos"}>{ObtenerSeccion1[0]?ObtenerSeccion1[0].contenido.titulo:""}</div>
                          <div className={"texto-descripcion-productos"}>
                          {ObtenerSeccion1[0]?ObtenerSeccion1[0].contenido.texto:""}
                          </div>
                      </Col>
                      <Col lg={3} md={12} sm={12} xs={12}>
                        <br></br>
                        <div className={"content-btn-vehiculos"}> 
                            <Col lg={12} md={12} sm={12} xs={12}>
                              Cotiza y obtén tu seguro ahora fácil y en segundos.  
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12}>
                              {mostrarBotonCotizar && 
                                <Button onClick={this.onClickCotizar} className="btn btn-purple btn btn-secondary">
                                ¡QUIERO COTIZAR !
                                </Button>
                              }
                              {mostrarBotonCotizar == false && 
                                <Button className=" productos-boton-deshabilitado">
                                ¡PRÓXIMAMENTE !
                                </Button>
                              }
                            </Col>                          
                        </div>
                      </Col>
                    </Row>
                    <div style={{paddingTop:"3em"}}></div>
                    <Row>
                      <Col lg={6} md={12} sm={12} xs={12}>
                          <div className={"titulo-acordeon-padding"}>
                            <div className={"titulo-acordeon-texto"}>{tituloAcordeon}</div>
                          </div>
                          <PreguntasVehiculos></PreguntasVehiculos>                         
                      </Col>
                      <Col lg={6} md={12} sm={12} xs={12}>
                        <img src={imgvehiculo} alt="" className={"img-productos"}/>
                      </Col>
                    </Row>
                    {this.props.datosContenido && this.props.datosContenido.contenidos && this.props.datosContenido.contenidos.materiales && this.props.datosContenido.contenidos.materiales[0] !== undefined && this.props.datosContenido.contenidos.materiales[0] !== null && 
                    <Row>
                      <Col lg={6} md={12} sm={12} xs={12}>                                      
                            <div className={"titulo-acordeon-padding"}>
                              <div className={"titulo-detalle-producto"}>Materiales</div><br></br>
                              {this.props.datosContenido.contenidos.materiales.map(({ contenido}) =>                                    
                                  <div>
                                      <a href={contenido.url_icono_img} target="_blank" rel="noopener noreferrer">{contenido.titulo}</a><br></br>
                                  </div>
                                )}
                                
                            </div>                                             
                      </Col>
                      <Col lg={6} md={12} sm={12} xs={12}></Col>
                    </Row>
                    }                     
                    {this.props.datosContenido && this.props.datosContenido.contenidos && this.props.datosContenido.contenidos.videos && this.props.datosContenido.contenidos.videos[0] !== undefined && this.props.datosContenido.contenidos.videos[0] !== null &&                     
                      <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <div className={"titulo-acordeon-padding"}>
                                <div className={"titulo-detalle-producto"}>Videos</div><br></br>
                                  <SliderVideos videos={this.props.datosContenido.contenidos.videos}/>
                              </div>                      
                        </Col>
                      </Row>
                    } 
                </Container>
            </div>
          </main>

      </LoadingScreen>

    );

  }
}

const mapStateToProps = state => ({
  datosContenido: state.datosContenido,
});

const mapDispatchToProps = dispatch => {
  return {
    obtenerContenido: (seccion, id) => dispatch(contenidosFetch(seccion,id)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerProductosMenu)
);

//export default ContainerProductosMenu